import { useEffect, useRef } from "react";

export function NotFoundPage() {
  const starsRef = useRef(null);

  useEffect(() => {
    const canvas = starsRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let W = 0;
    let H = 0;
    let stars = [];
    let animationId;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const createStar = () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1 + 0.2,
      a: Math.random(),
      da: (Math.random() * 0.005 + 0.001) * (Math.random() < 0.5 ? 1 : -1),
    });

    const init = () => {
      resize();
      stars = Array.from({ length: 160 }, createStar);
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      for (const star of stars) {
        star.a += star.da;

        if (star.a <= 0.04 || star.a >= 1) {
          star.da *= -1;
        }

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${star.a.toFixed(2)})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    window.addEventListener("resize", resize);

    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  useEffect(() => {
    const previousBackground = document.body.style.background;

    document.body.style.background = "#060410";
    document.body.style.margin = "0";
    document.body.style.padding = "0";

    return () => {
      document.body.style.background = previousBackground;
      document.body.style.margin = "";
      document.body.style.padding = "";
    };
  }, []);

  return (
    <>
      <canvas
        ref={starsRef}
        className="fixed inset-0 w-full h-full pointer-events-none"
      ></canvas>
      <div className="min-h-full py-36 flex flex-col text-white">
        <main className="grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="shrink-0 flex justify-center">
            <a href="/" className="inline-flex">
              <span className="sr-only">Galilea</span>
              <img
                className="h-32 w-auto"
                src="/svg/imagotipo-galilea-18.svg"
                alt="Galilea"
              />
            </a>
          </div>
          <div className="py-16">
            <div className="text-center">
              <p className="text-xl font-medium text-white uppercase tracking-wide">
                Error 404
              </p>
              <h1 className="mt-2 text-4xl font-medium tracking-tight sm:text-5xl">
                No encontramos esta página.
              </h1>
              <p className="mt-2 text-xl">
                Lo sentimos, no pudimos encontrar la página que estabas
                buscando.
              </p>
              <div className="mt-6">
                <a
                  href="/"
                  className="text-xl font-medium text-white items-center hover:text-purple"
                >
                  Volver a inicio <span aria-hidden="true"> &rarr;</span>
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
